import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-all-jobs')) {
  ReactDOM.render(
    <JobsTable
      url = "/api/v1/portal/jobs/all"
      infiniteScroll={true}
      message_if_none = 'No Jobs found. Add one to see it here.'
    />,

    document.getElementById('react-component-g4-logistics-portal-all-jobs'));
}
